import PropTypes from 'prop-types';

const FlagContentPropType = PropTypes.shape({
    name: PropTypes.string.isRequired,
    iconUrl: PropTypes.string.isRequired,
    identifier: PropTypes.string.isRequired,
});

export default FlagContentPropType;
